const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrollArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "1.9857347mm",
    height: "1.7264584mm",
    viewBox: "0 0 1.9857347 1.7264584",
    id: "svg8711",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "scroll_arrow_up.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8705"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 3.7525711,
    "inkscape:cy": 3.2643721,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8708"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(82.257749,-147.97057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -80.431444,149.53359 c -0.555625,0 -1.11125,0 -1.666875,0.004 0.279753,-0.4692 0.559859,-0.93839 0.839612,-1.40759 l 0.827263,1.40406",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    id: "path1204",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -80.431444,149.53359 c -0.555625,0 -1.11125,0 -1.666875,0.004 0.279753,-0.4692 0.559859,-0.93839 0.839612,-1.40759 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.31888396,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1206",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrowUp);
export default __webpack_public_path__ + "static/media/scroll_arrow_up.9b94bc96a9cba8011469c9f58840b618.svg";
export { ForwardRef as ReactComponent };